import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GenerateFormService, PerForm } from '@lbmx/per-form';
import {
  SpinnerService,
  ToastrNotificationService,
} from '@lbmx/phoenix-lib-utils';
import { BaseHttpService } from '@lbmx/web-core';
import { TranslocoService } from '@ngneat/transloco';
import { of } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';
import { schemaDefinition } from './assign-options.ui';

export interface UserAssignOptions {
  assignOption?: [];
}

export interface AssignOptionsForm {
  fields: object;
  errorCode?: number;
}

export interface SelectedAssignOptions {
  record?: {
    AssignOption?: number;
  };
  errorCode?: number;
}

@Component({
  selector: 'lib-assign-options-container',
  template: ` <lib-assign-options
    [form]="form"
    (closeDialog)="closeDialog.emit()"
    (saveDialog)="save($event)"
  ></lib-assign-options>`,
  styles: ['body .ui-dialog .ui-dialog-content { overflow-auto; }'],
})
export class AssignOptionsContainerComponent implements OnInit {
  @Input() public baseUrl: string;
  @Input() public selectedAssignOptions: any;
  @Output() public closeDialog = new EventEmitter();
  @Output() public updateAssignOptions = new EventEmitter();

  public form: PerForm;
  public schemaDefinition = schemaDefinition;
  constructor(
    private http: BaseHttpService,
    private spinner: SpinnerService,
    private translocoService: TranslocoService,
    private toast: ToastrNotificationService,
    private formGenerator: GenerateFormService
  ) {}

  public ngOnInit(): void {
    this.http
      .fetchWithFqn({
        endpoint: `${this.baseUrl}` + `/assign-options/form`,
        httpMethod: 'GET',
      })
      .pipe(
        tap(({ fields }: any) => {
          this.form = this.formGenerator.init(
            this.schemaDefinition(fields),
            this.selectedAssignOptions
          );
        }),
        catchError(() =>
          of(
            this.toast.errorNotify(
              this.translocoService.translate('MESSAGES.GENERIC_ERROR')
            )
          )
        )
      )
      .subscribe();
  }

  public save(formValues: any) {
    this.spinner.on();

    this.http
      .fetchWithFqn({
        endpoint: `${this.baseUrl}/assign-options`,
        httpMethod: 'POST',
        body: formValues,
      })
      .pipe(
        tap((response: any) => {
          this.toast.successNotify(
            this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE')
          );
          this.updateAssignOptions.emit();
          this.closeDialog.emit();
        }),
        catchError((error: any) => {
          if (error?.error?.errorCode === 5) {
            return of(
              this.toast.errorNotify(
                this.translocoService.translate(
                  'ANALYTICS_EXCLUSION.UNAUTHORIZED_TOAST_MESSAGE'
                )
              )
            );
          } else {
            return of(
              this.toast.errorNotify(
                this.translocoService.translate('MESSAGES.GENERIC_ERROR')
              )
            );
          }
        }),
        finalize(() => this.spinner.off())
      )
      .subscribe();
  }
}
